import { useIntl } from "react-intl";
import { WarningRed } from "sr/helpers/ui-components/company/WarningRed";

export const TrainingCertificationRequirementWarning = () => {
  const intl = useIntl();

  return (
    <WarningRed
      paragraph={intl.formatMessage({
        id: "RECRUITER.POSTJOB.REQUIRED.TRAINING_CERTIFICATION.WARNING",
        defaultMessage:
          "Warning: Only cleaners that have listed the required trainings or certifications on their profile will be able to apply to this job post.",
      })}
    />
  );
};

